module.exports = __webpack_public_path__ + "img/6c330ee1e63ebf8150b1105bae50484a.09b665b0.png";